/* eslint-disable import/no-unresolved */
import { createVuetify } from 'vuetify';
import '@mdi/font/css/materialdesignicons.css';
// TODO: 本当はこっちにしたい import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';

import { themes } from '@/tenant-data';

import 'vuetify/styles';

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes,
    variations: {
      // DatePicker用（darken: 3, lighten: 5）
      colors: ['primary'],
      lighten: 5,
      darken: 3,
    },
  },
  icons: {
    defaultSet: 'mdi',
    sets: {},
    // aliases,
    // sets: { mdi },
  },
  defaults: {
    VTextField: {
      bgColor: 'surface',
    },
  },
});
